import State from '../core/State';
import initialState from '../initialState';
import produce, { Draft } from 'immer';

export const startCreateNewPosition = () =>
  produce((draft: Draft<State>) => {
    draft.createNewPosition.fetching = initialState.createNewPosition.fetching + 1;
  });

export const finishCreateNewPosition = () =>
  produce((draft: Draft<State>) => {
    draft.createNewPosition.fetching = initialState.createNewPosition.fetching - 1;
  });
